import { Button, Image } from "antd";
import React, { useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";

import useMapData from "../../utils/useMapData";

import { ModalOverlay } from "../Modal/Modal";
import { CostDetailText } from "../../StyledCmp";

const FloorPlanCard = ({
  floorPlanType,
  floorPlanImage,
  floorText,
  masterFloorPlanImage,
}) => {
  const { propertyId } = useParams();
  const resultList = useMapData(propertyId);

  const isMasterPlan = floorPlanType === "master";
  const isFloorPlan = floorPlanType === "floor";

  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalVisibility = () => {
    setIsModalVisible(prevState => !prevState);
  };

  return (
    <div
      style={{
        margin: "1em",
      }}
    >
      <div className="content" onClick={handleModalVisibility}>
        <div className="content-overlay"></div>
        <Image
          src={isMasterPlan ? masterFloorPlanImage : floorPlanImage}
          onContextMenu={e => e.preventDefault()}
          preview={false}
          id="blur_image"
        />
        <div className="content-details fadeIn-bottom">
          <Button
            style={{ background: resultList?.themeColor }}
            id="content-title"
            icon={<EyeOutlined />}
          >
            Enquire Now
          </Button>
        </div>
      </div>
      {isFloorPlan && (
        <CostDetailText>
          <p style={{ color: resultList?.themeColor }}>{floorText}</p>
        </CostDetailText>
      )}
      {isModalVisible && (
        <ModalOverlay
          isModalVisible={isModalVisible}
          handleModalVisibility={handleModalVisibility}
          title={"Send Me Plan Details"}
          btnText="Send Now"
          actionType="send-plan-details"
        />
      )}
    </div>
  );
};

export default FloorPlanCard;
